<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
     <router-link :to="item.url" v-if="item.topMenu === 1&&item.url==='/index'">
        <el-menu-item :index="item.url">
          <i class="iconfont" :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.url" v-else>
        <template slot="title">
          <i class="iconfont" :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </template>
        <template>
          <el-menu-item-group v-for="(item2,index) in item.childMenus" :key="index">
            <router-link :to="item2.url">
              <el-menu-item :index="item2.url">{{
                item2.name
              }}</el-menu-item>
            </router-link>
          </el-menu-item-group>
        </template>
      </el-submenu>
    </template>
    <!-- <template v-for="item in routes" v-if="!item.hidden&&item.children">
      <router-link v-if="item.children.length===1 && !item.children[0].children&&item.path===''" :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
           <i class="iconfont" :class="item.meta.icon"></i><span v-if="item.children[0].meta&&item.children[0].meta.title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <i class="iconfont" :class="item.meta.icon"></i><span v-if="item.meta&&item.meta.title">{{item.meta.title}}</span>
        </template>
        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>
          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <span v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template> -->
  </div>
</template>

<script>
export default {
  name: 'sidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },mounted(){
    console.log(this.routes)
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/layout/components/sidebar/sidebarItem.vue